module.exports = __webpack_public_path__ + "img/PL08470.7f9721ff.png";